export const loginStaticData = {
  welcomeText: 'Welcome Back',
  signInText: 'Sign in to your account',
  emailText: 'Email',
  emailPlaceholder: 'Enter your email address',
  passwordText: 'Password',
  passwordPlaceholder: '8-10 digit password',
  incorrectMessage: 'Incorrect Email or Password',
  forgetPasswordtext: 'Forgot Password?',
  validEmailText: 'Please enter a valid email address',
  signInButton: 'Sign In',
  privacyPolicyText: 'Privacy Policy',
  termConditionText: 'Terms & Condition',
  loginImageText: 'Illustration In Progress',
  loginSuccessful: 'Login successful',
  notAuthorised: 'Not authorised user',
};

export const LoginHindiData = {
  welcomeText: 'वापसी पर स्वागत है',
  signInText: 'अपने खाते में साइन इन करें',
  emailText: 'ईमेल',
  emailPlaceholder: 'अपना ईमेल पता दर्ज करें',
  passwordText: 'पासवर्ड',
  passwordPlaceholder: '8-10 अंकों का पासवर्ड',
  incorrectMessage: 'गलत ईमेल या पासवर्ड',
  forgetPasswordtext: 'पासवर्ड भूल गए?',
  validEmailText: 'कृपया एक मान्य ईमेल पता दर्ज करें',
  signInButton: 'साइन इन करें',
  privacyPolicyText: 'गोपनीयता नीति',
  termConditionText: 'नियम और शर्तें',
  loginImageText: 'चित्रण प्रगति पर है',
  loginSuccessful: 'लॉगिन सफल',
  notAuthorised: 'अनधिकृत उपयोगकर्ता',
};

export const LoginArabicData = {
  welcomeText: 'مرحباً بعودتك',
  signInText: 'تسجيل الدخول إلى حسابك',
  emailText: 'البريد الإلكتروني',
  emailPlaceholder: 'أدخل عنوان بريدك الإلكتروني',
  passwordText: 'كلمة المرور',
  passwordPlaceholder: 'كلمة مرور من 8-10 أرقام',
  incorrectMessage: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
  forgetPasswordtext: 'نسيت كلمة المرور؟',
  validEmailText: 'يرجى إدخال عنوان بريد إلكتروني صحيح',
  signInButton: 'تسجيل الدخول',
  privacyPolicyText: 'سياسة الخصوصية',
  termConditionText: 'الشروط والأحكام',
  loginImageText: 'الرسم التوضيحي قيد التطوير',
  loginSuccessful: 'تم تسجيل الدخول بنجاح',
  notAuthorised: 'مستخدم غير مصرح له',
};
